import { ElMessageBox } from 'element-plus'

export function usePackageUpdate() {
  if (window.electron) {
    // 1.1 检查更新
    window.electron.toCheckForUpdate?.()

    // 2.1 监听更新过程中的事件

    // 捕获更新过程中的报错信息
    window.electron.onUpdateError?.((err) => {
      throw new Error(err)
    })

    // 检测到可用更新
    window.electron.onUpdateAvailable?.((info) => {
      // 触发安装包下载
      window.electron.toDownload?.()
    })

    // 监听下载完成事件
    window.electron.onUpdateDownloaded?.((info) => {
      ElMessageBox.confirm('检测到新版本，是否立即安装更新？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          window.electron.toInstall?.()
        })
        .catch(() => {
          console.log('取消安装')
        })
    })

    // 检测到无可用更新
    // window.electron.onUpdateNotAvailable?.((info) => {
    // })

    // 监测下载进度
    // window.electron.onDownloadProgress?.((progressObj) => {
    // })
  }
}
